export default "__VITE_ASSET__CQjC8KqX__"